<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Manage pipelines</h1>

                    <a :href="`/#/admin/integrations/pipelines/create/${tid}`" type="button" class="btn btn-link btn-sm">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                        <span>Create pipeline</span>
                    </a>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <div v-for="p in pipelines" :key="p.Id">
                <a :href="`/#/admin/integrations/pipelines/details/${tid}/${p.PipelineId}`">{{p.Name}}</a>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed, ref, reactive, watch, onMounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminManagePipelinesPage } from '@Integrations/Pipelines/pages-core'

    document.title = "Manage pipelines"

    const tid = useOrganizationUnitId()

    const { useCurrentUserQuery, useAllPipelinesQuery } = useAdminManagePipelinesPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { model, run } = useAllPipelinesQuery(tid)
    const pipelines = computed(() => model.value?.Pipelines || [])
    run()

    onMounted(() => {
        runCurrentUserQueryV1()
    })
</script>
